import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    updateChannel = new Subject()
    employeeListChannel = new Subject()
    gradeListChannel = new Subject()
    positionChannel = new Subject()
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.employeeListChannel.next({status: apiResponse.INITIAL})
        this.gradeListChannel.next({status: apiResponse.INITIAL})
        this.positionChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchEmployeeList = async (query) => {
        try {
            this.employeeListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeList(query).then((result) => {
                this.employeeListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeListChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchGradeList = async (query) => {
        try {
            this.gradeListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchGradeList(query).then((result) => {
                this.gradeListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.gradeListChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }
    fetchPositionList = async (query) => {
        try {
            this.positionChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPositionList(query).then((result) => {
                this.positionChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.positionChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

}

export default CreateBloc